import React, { Component } from "react";
import Dropzone from "react-dropzone";

// Components
import UploadProgress from "./UploadProgress";
import Modal from "../modal/Modal";
import Button from "../modal/Button";

class DropzoneWrapperSimple extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showError: false,
			files: [],
			existingFiles: !!props.initialImages ? props.initialImages : [],
			allowMultiple: props.multiple !== undefined && props.multiple,
			droppedImage: false // Flag to notify component something was dropped
		};
	}

	componentWillUnmount() {
		this.clearPreviewObject();
	}

	componentWillReceiveProps(nextProps) {
		// ** NOTE: There is a bug where the original "initialImages" will show up after a new image is uploaded and removed or something like that.
		// I'm unable to nail down the exact process to make this happen.  It's a logic bug but hard to fix when I can't replicate every time.

		// console.log(this.props.initialImages, nextProps.initialImages);

		// If the files are set to be cleared
		if (nextProps.clear && this.props.clear !== nextProps.clear) {
			// Clear the react-drop memory for the preview image
			this.clearPreviewObject();

			this.setState({
				files: [],
				droppedImage: false,
				existingFiles: !!nextProps.initialImages ? nextProps.initialImages : []
			});
		}

		// Update files (maybe loading now or something)
		if (nextProps.img.length) {
			this.setState({ files: nextProps.img });
		}

		// if (!nextProps.initialImages) return;

		// Compare the array collection of initial images.
		// It's an array of objects, so a simple isEqual wouldn't work
		// let equal = true;
		// for (let i = 0; i < nextProps.initialImages.length; i++) {
		// 	// console.log(this.state.existingFiles[i], nextProps.initialImages[i]);

		// 	// Item is not set on the other array
		// 	if (this.state.existingFiles[i] === undefined) {
		// 		equal = false;
		// 		break;
		// 	}

		// 	// Ensure both objects are equal (we don't care about size and date_edited)
		// 	if (!isEqual(omit(this.state.existingFiles[i], ["size", "date_edited"]), omit(nextProps.initialImages[i], ["size", "date_edited"]))) {
		// 		equal = false;
		// 		break;
		// 	}
		// }

		// // Update existsing images if there is any new info
		// if (!equal) {
		// 	this.setState({
		// 		existingFiles: !!nextProps.initialImages ? nextProps.initialImages : []
		// 	});
		// }
	}

	clearPreviewObject = () => {
		if (!this.state.files.length) return;
		this.state.files.forEach(file => {
			window.URL.revokeObjectURL(file.preview);
		});
	};

	onDrop = (acceptedFiles, rejectedFiles) => {
		const files = this.state.allowMultiple ? acceptedFiles : [acceptedFiles[0]];

		files.forEach(file => {
			this.readFile(file);
		});
	};

	readFile(file) {
		const reader = new FileReader();
		reader.onload = () => {
			const fileAsBinaryString = reader.result;
			file.fileString = fileAsBinaryString;

			file.alt = "";
			file.link = "";

			let existingFiles = [];
			let files = [file];

			if (!this.state.allowMultiple) {
				this.clearPreviewObject();

				// ** Note: Removed this because we don't want to remove the original image value
				//          The API might want it to keep track of whether or not to delete it
				// if (!!this.props.handleExistingImageRemoval) {
				// 	this.props.handleExistingImageRemoval();
				// }
			} else {
				existingFiles = [...this.state.existingFiles];
				files = [...this.state.files, file];
			}

			this.setState({
				existingFiles,
				files,
				droppedImage: true
			});
			this.props.handleImgUpdate(this.props.name, file);
		};
		reader.onabort = () => console.log("file reading was aborted");
		reader.onerror = () => console.log("file reading has failed");

		// ===================================
		//  Reading will fail if it's not an image
		// ===================================
		try {
			reader.readAsBinaryString(file);
		} catch (err) {
			this.setState({ showError: true });
			console.log(err);
		}
	}

	removeImage(e, index) {
		e.stopPropagation();
		let { files } = this.state;
		files.splice(index, 1);
		this.setState({
			files: files
		});
		this.props.handleImgRemoval(files);
	}

	removeExistingImage(e) {
		e.stopPropagation();
		let { existingFiles } = this.state;
		existingFiles.splice(0, 1);
		this.setState({
			existingFiles: existingFiles
		});

		// Call parent handler so it knows an image has been removed
		this.props.handleExistingImageRemoval();
	}

	formatName(name) {
		return name.substr(name.lastIndexOf("/") + 1);
	}

	render() {
		const { files, existingFiles } = this.state;

		// Dropped images
		const dropped = files.map((file, i) => {
			return (
				<div key={"dropped-" + i} className="multiple-drop-image new-img">
					<img src={file.preview} alt={file.preview} />
					<div className="icon-cross" onClick={e => this.removeImage(e, i)} />
					{file.loading && (
						<UploadProgress completed={file.completed} message={file.message} />
					)}
				</div>
			);
		});

		// Existing images
		const existing = existingFiles.map((file, i) => {
			return (
				<div key={"existing-" + i} className="multiple-drop-image">
					<img src={file} alt={file} />
					<div className="icon-cross" onClick={e => this.removeExistingImage(e, i)} />
				</div>
			);
		});

		// DEBUGGING!!!
		// console.log("Dropped: ", dropped, "Existing: ", existing);

		// Combine both types of images
		const images = dropped.concat(existing);

		// console.log('render state', this.state)
		// console.log(existing);

		return (
			<React.Fragment>
				<Dropzone
					onDrop={this.onDrop}
					accept="image/*"
					multiple={!!this.props.multiple ? this.props.multiple : false}
					className="dropzone"
					style={{ border: "none" }}
				>
					{/* There are images available */}
					{files.length || existingFiles.length ? (
						images
					) : (
							// There are no images yet
							<div className="txt">
								{this.props.placeholder
									? this.props.placeholder
									: `Drag image here or click to select image`}
							</div>
						)}
				</Dropzone>

				{this.state.showError && (
					<Modal
						title={"Error"}
						buttons={[
							{
								type: Button,
								text: "Close",
								action: () => {
									this.setState({ showError: false });
								}
							}
						]}
					>
						Unable to read file. Please try using another image.
					</Modal>
				)}
			</React.Fragment>
		);
	}
}

export default DropzoneWrapperSimple;



// WEBPACK FOOTER //
// ./src/components/utils/DropzoneWrapperSimple.js